module.exports = __webpack_public_path__ + "static/media/logo.c9c00c16.png";